import { Subject } from 'rxjs';

const settingsDeviceSubject = new Subject();

export const updateSettingsDeviceSubject = {
  update: message => settingsDeviceSubject.next(message),
  clear: () => settingsDeviceSubject.next(),
  get: () => settingsDeviceSubject.asObservable()
};
